import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Input,
  Label,
  Switch,
} from '@roger/ui-components';
import type { PainState } from '../assessmentFormTypes';

interface PainSectionProps {
  state: PainState;
  onChange: (update: Partial<PainState>) => void;
}

const PainSection: React.FC<PainSectionProps> = ({ state, onChange }) => (
  <AccordionItem value='pain' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Pain
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <div className='flex items-center gap-3'>
        <Switch
          id='pain-switch'
          checked={state.present}
          onCheckedChange={v => onChange({ present: v })}
        />
        <label htmlFor='pain-switch' className='text-sm cursor-pointer'>
          Patient reports pain
        </label>
      </div>
      {state.present && (
        <div className='space-y-1 max-w-[120px]'>
          <Label className='text-xs'>Pain Level (1–10)</Label>
          <Input
            type='number'
            min='1'
            max='10'
            step='1'
            value={state.level}
            onChange={e => {
              const v = e.target.value;
              if (v === '') {
                onChange({ level: '' });
                return;
              }
              const n = parseInt(v, 10);
              if (!isNaN(n))
                onChange({ level: String(Math.min(10, Math.max(1, n))) });
            }}
            inputSize='sm'
            className={
              state.level !== '' &&
              (parseInt(state.level, 10) < 1 || parseInt(state.level, 10) > 10)
                ? 'border-destructive'
                : undefined
            }
          />
        </div>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default PainSection;
